import { createFileRoute, redirect } from '@tanstack/react-router';
import { SignIn } from '@/pages/sign-in';
import { ADMIN_DASHBOARD, REFERRER_DASHBOARD } from '@/lib/constants/routes';
import { GlobalRole } from '@/lib/auth/models';
import { isAdminOrSystemRole } from '@/lib/auth/roles';
import { queryClient } from '@/api/common/client';
import {
  ensureAuthData,
  isAuthMeRequestError,
  SIGNED_OUT_ME,
} from '@/api/auth/auth-query';

/**
 * Sul login una verifica di `/me` non riuscita (5xx, rete) non blocca il
 * form: si entra con le credenziali, che riscrivono la sessione. Altrove la
 * stessa lettura mostra la schermata con «Riprova» e «Torna al login».
 */
async function readSessionForSignIn() {
  try {
    return await ensureAuthData(queryClient);
  } catch (error) {
    if (isAuthMeRequestError(error)) return SIGNED_OUT_ME;
    throw error;
  }
}

export const Route = createFileRoute('/sign-in')({
  beforeLoad: async () => {
    const data = await readSessionForSignIn();
    if (!data.authenticated || !data.user) return;

    const role = data.user.globalRole;
    if (isAdminOrSystemRole(role)) {
      throw redirect({ to: ADMIN_DASHBOARD });
    } else if (role === GlobalRole.REFERRER) {
      throw redirect({ to: REFERRER_DASHBOARD });
    }
  },
  component: SignIn,
});
